import { useTheme } from 'contexts'
import React from 'react'
import { Switch as RnSwitch, View } from 'react-native'

interface SwitchProps {
  disabled?: boolean
  isEnabled?: boolean
  onValueChanged?: (newValue: boolean) => void
}

export const Switch = ({
  disabled = false,
  isEnabled = false,
  onValueChanged = () => {},
}: SwitchProps) => {
  const { colors } = useTheme()
  return (
    <View>
      <RnSwitch
        disabled={disabled}
        trackColor={{
          false: colors.grey,
          true: colors.v2primary,
        }}
        // `activeThumbColor` is not part of the typings but is required to style the thumb color when
        // the switch is active
        // @ts-expect-error type activeThumbColor
        activeThumbColor={colors.white}
        thumbColor={colors.white}
        onValueChange={(newValue) => onValueChanged(newValue)}
        value={isEnabled}
      />
    </View>
  )
}
